<template>
    <div class="my-auto text-white">
        <h4 class="text-info">{{ $t('recoverypwd.title') }}</h4>
        <p class="text-white mb-4">{{ $t('recoverypwd.description') }}</p>
        <form @submit.prevent="handleSubmit">
            <div class="mb-3">
                <label for="email" class="form-label">{{ $t('common.email') }}</label>
                <input class="form-control" type="email" v-model="email" required :placeholder="$t('recoverypwd.emailPlaceholder')">
            </div>
            <div class="mb-0 text-center d-grid">
                <button class="btn btn-info" type="submit">{{ $t('recoverypwd.submit') }}</button>
            </div>
        </form>
    </div>

    <!-- Footer-->
    <footer class="footer footer-alt">
<p class="text-white">{{ $t('logout.backTo') }} <router-link to="/login" class="text-sidebar-link ms-1"><b>{{ $t('common.backToLogin') }}</b></router-link></p>
    </footer>
</template>

<script>
import { useUserStore } from '@/stores/userStore';
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
    name: 'RecoverypwdPage',
    setup() {
        const userStore = useUserStore();
        const router = useRouter();
        const { t } = useI18n();
        const email = ref('');

        const handleSubmit = async () => {
            await userStore.sendRecoveryPasswordLink(email.value);
            router.push({ path: "/result", query: {success: true, title: t('recoverypwd.successTitle'), message: t('recoverypwd.successMessage')}});
        };

        return {
            handleSubmit,
            email,
        }
    }
}
</script>
